import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: String(import.meta.env.VITE_SENTRY_DSN ?? ""),
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});
